import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ServicesPricing.css";

/**
 * ServicesPricing
 * Acts only as the chooser at /service-prices
 * Clicking Dog or Cat navigates to /service-prices/dog or /service-prices/cat
 * Back-compat: if someone visits with #dog or #cat, we redirect to the new routes.
 */
export default function ServicesPricing() {
  const navigate = useNavigate();
  const location = useLocation();

  // Backwards compatibility for old links using #dog or #cat
  useEffect(() => {
    const hash = String(window.location.hash || "").replace("#", "").toLowerCase();
    if (hash === "dog") navigate("/service-prices/dog", { replace: true });
    if (hash === "cat") navigate("/service-prices/cat", { replace: true });
    // Clean up stray hashes
    if (hash === "dog" || hash === "cat") {
      try { window.history.replaceState(null, "", location.pathname); } catch (e) {}
    }
  }, [navigate, location.pathname]);

  function goDog() { navigate("/service-prices/dog"); }
  function goCat() { navigate("/service-prices/cat"); }

  return (
    <div className="chooser-fullscreen" role="tablist" aria-label="Choose pet">
      <button
        role="tab"
        aria-selected="false"
        className="chooser-half chooser-half--top chooser-dog"
        onClick={goDog}
        onKeyDown={(e) => { if (e.key === "ArrowDown") goCat(); if (e.key === "Enter") goDog(); }}
      >
        <div className="chooser-label">
          <div className="chooser-title">Dog</div>
        </div>
      </button>

      <button
        role="tab"
        aria-selected="false"
        className="chooser-half chooser-half--bottom chooser-cat"
        onClick={goCat}
        onKeyDown={(e) => { if (e.key === "ArrowUp") goDog(); if (e.key === "Enter") goCat(); }}
      >
        <div className="chooser-label">
          <div className="chooser-title left">Cat</div>
        </div>
      </button>
    </div>
  );
}
